import React from "react";
import {
  IconButton,
  Tooltip,
  TextInput,
  useCopyToClipboard,
} from "@zapier/design-system";
import styles from "./CopyToClipboardTextarea.module.css";

type Props = {
  value: string;
  rows?: number;
};
function CopyToClipboardTextarea({ value, rows = 20 }: Props) {
  const [didCopy, handleCopyText] = useCopyToClipboard(value);
  const onClickCopy = () => {
    handleCopyText();
  };
  const ariaLabel = didCopy
    ? "Copied to clipboard!"
    : "Copy value to the clipboard";

  return (
    <div className={styles.copyToClipboardTextInputWrapper}>
      <TextInput
        value={value}
        isReadonly={true}
        isMultiline={true}
        rows={rows}
      />
      <div className={styles.copyButton}>
        <Tooltip content={ariaLabel} placement="left">
          <IconButton
            aria-label={ariaLabel}
            name="actionCopy"
            size="small"
            variant="ghost"
            onPress={onClickCopy}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default CopyToClipboardTextarea;
